import React from 'react';
import styled from 'styled-components';
import axios from 'axios';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import get from 'lodash/get';

import AppShell from '../../components/AppShell';
import FormBuilder from '../../components/FormBuilder';
import Loader from '../../components/Loader';

class Venue extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      data: null,
      errorMessages: {},
    };
  }

  componentDidMount() {
    this.fetchVenuForm();
  }

  fetchVenuForm = async () => {
    try {
      const {
        data: { data },
      } = await axios.options('https://us-central1-jyp-admin-saas.cloudfunctions.net/venue/');
      this.setState({ loading: false, data });
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      this.setState({ loading: false, data: null });
    }
  };

  submitForm = async (formData) => {
    this.setState({ loading: true });
    try {
      await axios.post('https://us-central1-jyp-admin-saas.cloudfunctions.net/venue/', formData);
      this.setState({ loading: false });
    } catch (error) {
      const errorMessages = get(error, 'response.data.data.errors');
      this.setState({
        loading: false,
        errorMessages: errorMessages || {},
      });
    }
  };

  render() {
    const { loading, data, errorMessages } = this.state;
    return (
      <AppShell>
        {loading && <Loader />}
        {data && (
          <div>
            <FormContainer>
              <FormBuilder
                config={data}
                errors={errorMessages}
                renderFormActions={({ validateForm, formData }) => (
                  <Button
                    variant="raised"
                    color="primary"
                    onClick={() => {
                      if (validateForm(formData)) {
                        this.submitForm(formData);
                      }
                    }}
                  >
                    Update Venue
                  </Button>
                )}
              />
            </FormContainer>
          </div>
        )}
      </AppShell>
    );
  }
}

export default Venue;

const FormContainer = styled(Card)`
  max-width: 600px;
  padding: 16px;
`;



// WEBPACK FOOTER //
// ./src/pages/Venue/Venue.js